import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { translations } from './translations';

export function useLanguage() {
  const location = useLocation();
  const navigate = useNavigate();

  const lang = location.pathname.startsWith('/en') ? 'en' : 'no';

  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  useEffect(() => {
    if (location.pathname === '/' && !localStorage.getItem('lang-preference')) {
      const browserLang = navigator.language || '';
      if (browserLang.startsWith('en')) {
        localStorage.setItem('lang-preference', 'en');
        navigate('/en/', { replace: true });
        return;
      }
      localStorage.setItem('lang-preference', 'no');
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const t = (key) => translations[lang]?.[key] || key;

  return { lang, t };
}
